import axiosInstance from '../api';
import { ExternalVideo, ExternalVideoFilters, ExternalVideoListResponse } from './externalVideoApi.types';

export const fetchExternalVideos = async (
  filters?: ExternalVideoFilters
): Promise<ExternalVideoListResponse> => {
  const params: Record<string, string | number> = {};
  if (filters?.source_key) params.source_key = filters.source_key;
  if (filters?.status) params.status = filters.status;
  if (filters?.limit !== undefined) params.limit = filters.limit;
  if (filters?.offset !== undefined) params.offset = filters.offset;
  if (filters?.sortOrder !== undefined) params.sortOrder = filters.sortOrder;

  const response = await axiosInstance.get<ExternalVideoListResponse>('/external-videos', { params });
  return response.data;
};

export const fetchExternalVideoById = async (
  id: string
): Promise<ExternalVideo> => {
  const response = await axiosInstance.get<ExternalVideo>(`/external-videos/${id}`, {
    headers: { 'X-Skip-Auth-Error': 'true' },
  });
  return response.data;
};

/**
 * ストリームトークンを取得する（許可チェック含む）
 * 403: 許可なし / 500: チェック失敗
 */
export const fetchStreamToken = async (
  id: string,
  signal?: AbortSignal
): Promise<{ token: string }> => {
  const response = await axiosInstance.post<{ token: string }>(
    `/external-videos/${id}/stream-token`,
    undefined,
    { headers: { 'X-Skip-Auth-Error': 'true' }, signal }
  );
  return response.data;
};

/**
 * ストリームトークン付きのストリームURLを生成する
 *
 * 受容リスク: トークンがURLクエリパラメータに含まれるため、ブラウザ履歴やRefererに記録される可能性がある。
 * <video> タグの src 属性は URL 形式が必須のため、Authorization ヘッダーは使用不可。
 * トークンは30分有効・purpose限定・video ID紐付きのため、リスクは限定的と判断。
 */
export const getExternalVideoStreamUrl = (id: string, streamToken: string): string => {
  return `/api/external-videos/${id}/stream?token=${streamToken}`;
};

export const fetchRelatedExternalVideos = async (
  id: string
): Promise<ExternalVideo[]> => {
  const response = await axiosInstance.get<ExternalVideo[]>(`/external-videos/${id}/related`);
  return response.data;
};

/**
 * 認証付きでサムネイルを取得し、blob URL を返す
 * axiosInstance を使用してインターセプター（トークンリフレッシュ等）を適用
 */
export const fetchExternalVideoThumbnail = async (id: string, signal?: AbortSignal): Promise<string> => {
  const response = await axiosInstance.get<Blob>(`/external-videos/${id}/thumbnail`, {
    responseType: 'blob',
    headers: { 'X-Skip-Auth-Error': 'true' },
    signal,
  });
  return URL.createObjectURL(response.data);
};
